var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Home component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconHome extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.491 1.30388C11.7783 1.03896 12.2208 1.03896 12.508 1.30388L22.1551 10.2016C22.3902 10.4197 22.5774 10.6844 22.7048 10.9788C22.8317 11.2724 22.8963 11.589 22.8945 11.9088C22.8945 11.9098 22.8945 11.9107 22.8945 11.9116L22.1445 11.9065H22.8945V11.9088V20.5844C22.8945 21.1973 22.6511 21.785 22.2177 22.2184C21.7844 22.6517 21.1966 22.8952 20.5838 22.8952H3.4153C2.80244 22.8952 2.21469 22.6517 1.78134 22.2184C1.34798 21.785 1.10453 21.1973 1.10453 20.5844V11.9088C1.10453 11.9098 1.10454 11.9107 1.10455 11.9116L1.85453 11.9065H1.10453V11.9088C1.10275 11.589 1.16737 11.2724 1.29431 10.9788C1.42161 10.6844 1.60881 10.4197 1.84399 10.2016L1.84548 10.2003L11.491 1.30388ZM2.86332 11.3021C2.86311 11.3023 2.86353 11.3019 2.86332 11.3021C2.7811 11.3785 2.71564 11.4712 2.67109 11.5742C2.62642 11.6775 2.60375 11.7889 2.60451 11.9015L2.60455 11.9065L2.60453 20.5844C2.60453 20.7995 2.68995 21.0057 2.842 21.1577C2.99405 21.3098 3.20027 21.3952 3.4153 21.3952H20.5838C20.7988 21.3952 21.005 21.3098 21.1571 21.1577C21.3091 21.0057 21.3945 20.7995 21.3945 20.5844V11.9015C21.3953 11.7889 21.3726 11.6775 21.328 11.5742C21.2834 11.4711 21.2179 11.3785 21.1357 11.3021C21.1355 11.3019 21.1359 11.3022 21.1357 11.3021L11.9995 2.87549L2.86332 11.3021Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconHome.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconHome.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconHome.prototype, "size", void 0);
if (customElements.get('cat-icon-home') === undefined) {
    customElements.define('cat-icon-home', BlocksIconHome);
}
